module.exports = __webpack_public_path__ + "../resources/img/ic_cancel.a5df0417.svg";